<div class="report-action-links">
    <button class="btn btn-link" type="submit" (click)="viewPdfClicked()">
        <i class="fa-regular fa-file-pdf" aria-hidden="true"></i> View As PDF
    </button>
</div>

<div *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" class="warnings">
    <div class="sp-warning" *ngIf="isInOlderFiscalYear">
        <i class="fa fa-warning"></i>
        <div class="message">
            You are viewing an older fiscal year. To get better real-time reporting, please advance your planning year.
        </div>
    </div>
    <div class="sp-warning" *ngIf="reportData?.header?.missingGlCodesConfig && property.integrationName == 'Vantaca'">
        <i class="fa fa-warning"></i>
        <div class="message">
            Your property has missing general ledger configurations. Please <a
                href="/#/useraccount/properties/details?tab=connected-apps&tabIndex=2">configure</a> your GL codes for better reporting.
        </div>
    </div>
    <div class="sp-warning" *ngIf="reportData?.header?.missingGlCodesConfig && property.integrationName != 'Vantaca'">
        <i class="fa fa-warning"></i>
        <div class="message">
            Your property has missing general ledger configurations. Please <a
                href="/#/useraccount/properties/details?tab=connected-apps&tabIndex=2">configure</a> your GL codes for better reporting.
        </div>
    </div>

    <div class="sp-warning" *ngIf="reportData?.header?.missingBankAccountsConfig && property.integrationName == 'Vantaca'">
        <i class="fa fa-warning"></i>
        <div class="message">
            Your property may have missing bank account configurations. Please <a [routerLink]="['/useraccount/accounts']">configure</a> your bank account funds for better reporting.
        </div>
    </div>
    <div class="sp-warning" *ngIf="reportData?.header?.missingBankAccountsConfig && property.integrationName != 'Vantaca'">
        <i class="fa fa-warning"></i>
        <div class="message">
            Your property may have missing bank account configurations. Please <a
            [routerLink]="['/useraccount/accounts']">configure</a> your bank account funds for better reporting.
        </div>
    </div>
</div>

<div class="integration-dashboard-header">
    <div class="last-updated">
        Last Updated: {{reportData?.header?.reportPreparedDate | date: 'MMMM dd, yyyy'}}
    </div>
</div>

<div [hidden]="hasNoComponents">
    <div class="row">

    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="row key-insights-row">
                <div class="key-insights-card">
                    <strong>
                        {{reportData?.currentReserveBalance | currency:'USD':'symbol-narrow':'1.0-0' }}
                        <i id="currentReserveBalanceInsight" class="fa fa-circle-info key-insights-info-icon"></i>
                        <dx-popover target="#currentReserveBalanceInsight" showEvent="mouseenter" [hideEvent]="{ name: 'mouseleave', delay: 200 }"
                        (onHiding)="onPopoverHiding($event)">
                            <div *dxTemplate="let data = model; of: 'content'">
                                <div class="tooltip-container">
                                    <div class="tooltip-text-info">The total reserve balance is a summation of the latest balance for all of your
                                    reserve accounts listed in the <a [routerLink]="['/useraccount/accounts']">Accounts</a> section.</div>
                                    <div class="tooltip-row">
                                        <div class="col-md-3 header">Last Date</div>
                                        <div class="col-md-6 header text-start">Account</div>
                                        <div class="col-md-2 header">Balance</div>
                                    </div>
                                    <ng-container *ngFor="let account of reserveAccountBalances">
                                        <div class="tooltip-row">
                                            <div class="col-md-3">{{account.balanceDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-6 text-start">{{account.description}}</div>
                                            <div class="col-md-2"><sp-fr [data]="account.balance"></sp-fr></div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </dx-popover>
                    </strong>
                    <span>Total Reserve Balance</span>
                </div>
                <div class="key-insights-card">
                    <strong>
                        {{reportData?.currentOperatingBalance | currency:'USD':'symbol-narrow':'1.0-0' }}
                        <i id="currentOperatingBalanceInsight" class="fa fa-circle-info key-insights-info-icon"></i>
                        <dx-popover target="#currentOperatingBalanceInsight" showEvent="mouseenter" [hideEvent]="{ name: 'mouseleave', delay: 200 }"
                        (onHiding)="onPopoverHiding($event)">
                            <div *dxTemplate="let data = model; of: 'content'">
                                <div class="tooltip-container">
                                    <div class="tooltip-text-info">The total operating balance is a summation of the latest balance for all of your
                                        operating accounts listed in the <a [routerLink]="['/useraccount/accounts']">Accounts</a> section.</div>
                                    <div class="tooltip-row">
                                        <div class="col-md-3 header">Last Date</div>
                                        <div class="col-md-6 header text-start">Account</div>
                                        <div class="col-md-2 header">Balance</div>
                                    </div>
                                    <ng-container *ngFor="let account of operatingAccountBalances">
                                        <div class="tooltip-row">
                                            <div class="col-md-3">{{account.balanceDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-6 text-start">{{account.description}}</div>
                                            <div class="col-md-2"><sp-fr [data]="account.balance"></sp-fr></div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </dx-popover>
                    </strong>
                    <span>Total Operating Balance</span>
                </div>

                <!-- <div *ngIf="reportData?.currentOtherBalance > 0" class="key-insights-card">
                    <strong>
                        {{reportData?.currentOtherBalance | currency:'USD':'symbol-narrow':'1.0-0' }}
                        <i id="currentOtherBalanceInsight" class="fa fa-circle-info key-insights-info-icon"></i>
                        <dx-popover target="#currentOtherBalanceInsight" showEvent="mouseenter" [hideEvent]="{ name: 'mouseleave', delay: 200 }"
                        (onHiding)="onPopoverHiding($event)">
                            <div *dxTemplate="let data = model; of: 'content'">
                                <div class="tooltip-container">
                                    <div class="tooltip-text-info">The total other balance is a summation of the latest balance for all of your
                                        non-reserve and non-operating accounts in {{property?.integrationName}}.</div>
                                    <div class="tooltip-row">
                                        <div class="col-md-3 header">Last Date</div>
                                        <div class="col-md-6 header text-start">Account</div>
                                        <div class="col-md-2 header">Balance</div>
                                    </div>
                                    <ng-container *ngFor="let account of otherAccountBalances">
                                        <div class="tooltip-row">
                                            <div class="col-md-3">{{account.balanceDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-6 text-start">{{account.description}}</div>
                                            <div class="col-md-2"><sp-fr [data]="account.balance"></sp-fr></div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </dx-popover>
                    </strong>
                    <span>Total Other Balance</span>
                </div> -->
                <div class="key-insights-card">
                    <strong>
                        {{reportData?.monthlyAssessmentPerUnit | currency:'USD':'symbol-narrow':'1.0-0' }}
                        <i id="monthlyAssessmentPerUnitInsight" class="fa fa-circle-info key-insights-info-icon"></i>
                        <dx-popover target="#monthlyAssessmentPerUnitInsight" [width]="350" showEvent="mouseenter"
                            [hideEvent]="{ name: 'mouseleave', delay: 200 }"
                            (onContentReady)="onDxPopoverContentReady($event)" (onHiding)="onDxPopoverHiding($event)">
                            <div *dxTemplate="let data = model; of: 'content'">
                                <div class="key-insights-popover-content">
                                    The monthly {{ 'assessment' | terminology | async }} amount is calculated using the SmartProperty projections for {{
                                    fiscalYear?.yearRange }}. The annual {{ 'assessment' | terminology | async }} amount is set under <a
                                        class="btn btn-link padding-right-0" target="_blank"
                                        [routerLink]="['/useraccount/properties/details']" [queryParams]="{tab: 'financials'}">Financials</a> → Annual
                                    {{ 'Assessment' | terminology | async }} Fee.
                                </div>
                            </div>
                        </dx-popover>
                    </strong>
                    <span>{{ fiscalYear?.yearRange }} Monthly {{ 'Assessment' | terminology | async }} (Avg per {{ 'unit' | terminology | async }})</span>
                </div>
                <div class="key-insights-card">
                    <strong>
                        {{reportData?.monthlyReserveContributionPerUnit | currency:'USD':'symbol-narrow':'1.0-0'}}
                        <i id="monthlyReserveContributionPerUnitInsight"
                            class="fa fa-circle-info key-insights-info-icon"></i>
                        <dx-popover target="#monthlyReserveContributionPerUnitInsight" [width]="350"
                            showEvent="mouseenter" [hideEvent]="{ name: 'mouseleave', delay: 200 }"
                            (onContentReady)="onDxPopoverContentReady($event)" (onHiding)="onDxPopoverHiding($event)">
                            <div *dxTemplate="let data = model; of: 'content'">
                                <div class="key-insights-popover-content">
                                    The monthly reserve contribution is calculated using the SmartProperty projections
                                    for
                                    {{ fiscalYear?.yearRange }}. The annual reserve contribution amount is set under <a
                                        class="btn btn-link padding-right-0" target="_blank"
                                        [routerLink]="['/useraccount/properties/details']" [queryParams]="{tab: 'financials'}">Financials</a> →
                                    Annual Reserve Contributions.
                                </div>
                            </div>
                        </dx-popover>
                    </strong>
                    <span>{{ fiscalYear?.yearRange }} Monthly Reserve Contribution (Avg per {{ 'unit' | terminology | async }})</span>
                </div>
            </div>
        </div>
    </div>
<div class="row transactions-link">
    <div class="col-md-12 text-end">
        <a class="btn btn-link no-text-transform" routerLinkActive="router-link-active" [routerLink]="['/useraccount/transactions']">
        <span>View All Transactions</span>
        </a>
    </div>
</div>
    <div class="row">
        <div class="col-md-6">

            <!-- Reserve Expenses YTD-->
            <div class="section-container">
                <span class="section-title ">{{ fiscalYear?.yearRange }} Reserve Expenses</span>

                <div *ngIf="!dxReserveExpensesChartData.hasNoData" class="report-chart-small">
                    <dx-chart #reserveExpensesBarChart id="reserve-expenses-bar-chart"
                        [dataSource]="dxReserveExpensesChartData.data" [palette]="dxBarChartRedPalette"
                        [rotated]="true">

                        <!-- Data Mapping Setup-->
                        <dxo-chart-common-series-settings argumentField="name" valueField="value" type="bar"
                            [ignoreEmptyPoints]="true">
                        </dxo-chart-common-series-settings>
                        <dxo-chart-series-template nameField="name"></dxo-chart-series-template>

                        <!-- Axis Formatting (Both Axes)-->
                        <dxo-chart-common-axis-settings opacity="0">
                            <dxo-chart-tick [visible]="false"></dxo-chart-tick>
                            <dxo-chart-label>
                                <dxo-chart-font color="#000000" size="14" weight="300"
                                    family="MuseoSans-500, sans-serif"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-common-axis-settings>

                        <!-- Value Axis -->
                        <dxi-chart-value-axis>
                            <dxo-chart-label format="currency"></dxo-chart-label>
                        </dxi-chart-value-axis>

                        <!-- Argument Axis -->
                        <dxo-chart-argument-axis [inverted]="true"></dxo-chart-argument-axis>

                        <!-- Hover Tooltip -->
                        <dxo-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            interactive="true" paddingLeftRight="25" [zIndex]="2000">
                        </dxo-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container">

                                <div class="tooltip-row margin-bottom-10">
                                    <div class="col-md-10 text-start tooltip-total">{{ fiscalYear?.yearRange }} Total
                                        {{info.argument}} Expenses
                                    </div>
                                    <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                </div>

                                <!-- "Projected" Tooltip -->
                                <ng-container *ngIf="info.argument === 'Projection'">
                                    <div class="tooltip-row">
                                        <div class="col-md-12 text-muted">Top
                                            {{dxReserveExpensesTooltipProjectedData.length}} Projected Expenses</div>
                                    </div>

                                    <ng-container *ngFor="let tooltipData of dxReserveExpensesTooltipProjectedData">
                                        <div class="tooltip-row">
                                            <div class="col-md-10 text-start">{{tooltipData.name}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.currentCost"></sp-fr></div>
                                        </div>
                                    </ng-container>
                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/reports/anticipated-expenditures']">View
                                            All</a>
                                    </div>
                                </ng-container>

                                <!-- "Actual YTD" Tooltip -->
                                <ng-container *ngIf="info.argument === 'Actual YTD'">
                                    <div class="tooltip-row">
                                        <div class="col-md-12 text-muted">Top
                                            {{dxReserveExpensesTooltipActualData.length}} Expenses</div>
                                    </div>

                                    <ng-container *ngFor="let tooltipData of dxReserveExpensesTooltipActualData">
                                        <div class="tooltip-row">
                                            <div class="col-md-2 text-start">{{tooltipData.transactionDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-3 text-center">{{tooltipData.glCode}}</div>
                                            <div class="col-md-5 text-start">{{tooltipData.transactionDescription}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.amount"></sp-fr></div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/transactions']" [queryParams]="{
                                                reportingGroup: [reportingGroupTypes.ReserveExpense], 
                                                transactionDateStart: fiscalYearStartDate | date : 'MM-dd-yyyy',
                                                transactionDateEnd: fiscalYearEndDate | date : 'MM-dd-yyyy',
                                                fundTypes: fundTypesForExpense
                                            }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-chart-legend [visible]="true" position="side" horizontalAlignment="center" verticalAlignment="bottom"></dxo-chart-legend>
                    </dx-chart>
                </div>
                <div *ngIf="dxReserveExpensesChartData.hasNoData" class="report-chart-small-has-no-data">
                    <div class="alert alert-info chart-alert">
                        No data available for this chart. Please confirm your <a
                            href="/#/useraccount/properties/details?tab=connected-apps&tabIndex=2">configurations</a> are accurate.
                    </div>
                </div>
            </div>

            <!-- Reserve Income YTD -->
            <div class="section-container">
                <span class="section-title ">{{ fiscalYear?.yearRange }} Reserve Income YTD</span>

                <div *ngIf="!dxReserveContributionsChartData.hasNoData" class="report-chart-small">
                    <dx-chart #reserveContributionsBarChart id="reserve-contributions-bar-chart"
                        [dataSource]="dxReserveContributionsChartData.data" [palette]="dxBarChartGreenPalette"
                        [rotated]="true">

                        <!-- Data Mapping Setup-->
                        <dxo-chart-common-series-settings argumentField="name" type="stackedBar"
                            [ignoreEmptyPoints]="true">
                        </dxo-chart-common-series-settings>
                        <dxi-chart-series valueField="0" name="Projected" tag="0"></dxi-chart-series>
                        <dxi-chart-series valueField="1" name="Contribution" tag="1" color="#6db30b"></dxi-chart-series>
                        <dxi-chart-series valueField="2" name="Interest" tag="2" color="#0bb37b"></dxi-chart-series>
                        <dxi-chart-series valueField="7" [name]="specialAssessmentLabel" tag="7" color="#6dbde8"></dxi-chart-series>
                        <dxi-chart-series valueField="3" name="Other" tag="3" color="#a2cf63"></dxi-chart-series>

                        <!-- Axis Formatting (Both Axes)-->
                        <dxo-chart-common-axis-settings opacity="0">
                            <dxo-chart-tick [visible]="false"></dxo-chart-tick>
                            <dxo-chart-label>
                                <dxo-chart-font color="#000000" size="14" weight="300"
                                    family="MuseoSans-500, sans-serif"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-common-axis-settings>

                        <!-- Value Axis -->
                        <dxi-chart-value-axis>
                            <dxo-chart-label format="currency"></dxo-chart-label>
                        </dxi-chart-value-axis>

                        <!-- Argument Axis -->
                        <dxo-chart-argument-axis [inverted]="true"></dxo-chart-argument-axis>

                        <!-- Hover Tooltip -->
                        <dxo-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            interactive="true" paddingLeftRight="25" [zIndex]="2000">
                        </dxo-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container">

                                <!-- "Budget YTD" Tooltip -->
                                <ng-container *ngIf="info.argument === 'Budget YTD'">
                                    <!-- Series Total-->
                                    <div class="tooltip-row  margin-bottom-10">
                                        <div class="col-md-10 text-start tooltip-total">Total {{ info.seriesName }}
                                        </div>
                                        <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                    </div>

                                    <ng-container *ngFor="let tooltipData of dxReserveContributionsTooltipBudgetData">
                                        <div class="tooltip-row">
                                            <div class="col-md-10 text-start">
                                                {{tooltipData.date | date: 'MMM yyyy'}}
                                            </div>
                                            <div class="col-md-2"><sp-fr
                                                    [data]="tooltipData.reserveContribution"></sp-fr></div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <!-- "Actual YTD" Tooltip -->
                                <ng-container *ngIf="info.argument === 'Actual YTD'">
                                    <!-- Total Reserve Income-->
                                    <div class="tooltip-row  margin-bottom-10">
                                        <div class="col-md-10 text-start tooltip-total-income">Total Reserve Income
                                        </div>
                                        <div class="col-md-2 tooltip-total-income">{{ this.totalReserveIncome | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>
                                    
                                    <!-- Series Total-->
                                    <div class="tooltip-row  margin-bottom-10">
                                        <div class="col-md-10 text-start tooltip-total">Total {{ info.seriesName }}
                                        </div>
                                        <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                    </div>
                                    
                                    <!-- Items-->
                                    <ng-container *ngFor="let tooltipData of dxReserveContributionsTooltipActualData(info.point.series.tag)">
                                        <div class="tooltip-row">
                                            <div class="col-md-2 text-start">{{tooltipData.transactionDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-3 text-center">{{tooltipData.glCode}}</div>
                                            <div class="col-md-5 text-start">{{tooltipData.transactionDescription}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.amount"></sp-fr></div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/transactions']" [queryParams]="{
                                                reportingGroup: info.point.series.tag,
                                                transactionDateStart: fiscalYearStartDate | date : 'MM-dd-yyyy',
                                                transactionDateEnd: fiscalYearEndDate | date : 'MM-dd-yyyy',
                                                fundTypes: fundTypesForIncome
                                            }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-chart-legend [visible]="true" [customizeItems]="hideLegendLabelIfZero" position="side" horizontalAlignment="center" verticalAlignment="bottom"></dxo-chart-legend>
                    </dx-chart>
                </div>
                <div *ngIf="dxReserveContributionsChartData.hasNoData" class="report-chart-small-has-no-data">
                    <div class="alert alert-info chart-alert">
                        No data available for this chart. Please confirm your <a
                            href="/#/useraccount/connected-apps?tabIndex=2">configurations</a> are accurate.
                    </div>
                </div>
            </div>
        </div>

        <!-- Projected Expenses by Category Pie Chart -->
        <div class="col-md-6">
            <div class="section-container" id="projected-expenses-by-category-section">

                <span class="section-title">SmartProperty Projected Expenses by Category</span>

                <div class="row margin-top-10 justify-content-center">
                    <div class="col-md-3">
                        <select class="sp-select form-control"
                            (change)="refreshProjectedExpensesByCategoryChart($event.target.value)">
                            <option value="1" selected>{{ fiscalYear?.yearRange }}</option>
                            <option value="5">5 years</option>
                            <option value="10">10 years</option>
                        </select>
                    </div>
                </div>

                <div *ngIf="!dxProjectedExpensesByCategoryChart.hasNoData">
                    <dx-pie-chart #projectedExpensesByCategoryPieChart id="projected-expenses-by-category-pie-chart"
                        [dataSource]="dxProjectedExpensesByCategoryChart.data" [palette]="dxPieChartPalette"
                        paletteExtensionMode="alternate" resolveLabelOverlapping="hide">

                        <!-- <dxo-size [height]="325"></dxo-size> -->

                        <!-- Title -->
                        <dxo-pie-chart-title text="{{ projectedExpensesPieChartSubtitle }}" verticalAlignment="top"
                            horizontalAlignment="right">
                            <dxo-pie-chart-font weight="900" color="#222a32" size="16"
                                family="MuseoSans-500, sans-serif"></dxo-pie-chart-font>
                        </dxo-pie-chart-title>

                        <!-- Data Mapping Setup-->
                        <dxi-pie-chart-series argumentField="categoryName" valueField="anticipatedCost">
                            <dxo-pie-chart-label [visible]="true" position="columns" backgroundColor="none"
                                [customizeText]="customizeDxPieChartLabel">
                                <dxo-pie-chart-connector [visible]="true" [width]="1"></dxo-pie-chart-connector>
                                <dxo-pie-chart-font color="#000000" weight="300" family="MuseoSans-500, sans-serif"
                                    size="14"></dxo-pie-chart-font>
                            </dxo-pie-chart-label>
                        </dxi-pie-chart-series>

                        <!-- Hover Tooltip -->
                        <dxo-pie-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            paddingLeftRight="25" location="edge" [zIndex]="2000">
                        </dxo-pie-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container tooltip-container-small">
                                {{info.argument}}
                                <br />
                                <strong><sp-fr [data]="info.value"></sp-fr> ({{info.percentText}})</strong>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-pie-chart-legend [visible]="false"></dxo-pie-chart-legend>
                    </dx-pie-chart>
                </div>
                <div *ngIf="dxProjectedExpensesByCategoryChart.hasNoData" class="no-data-alert">
                    <div class="sp-warning">
                        <i class="fa fa-warning"></i>
                        <div class="message">
                            {{ projectedExpensesPieChartNoDataMessage }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Expenditures by Category -->
    <div class="row">
        <div class="col-lg-12">
            <div class="section-container">
                <span class="section-title ">{{ fiscalYear?.yearRange }} Expenditures by Category</span>
                <div *ngIf="dxExpenditureByCategoryChartData.data.length > 0">
                    <dx-chart #expendituresByCategoryBarChart id="expenditures-by-category-bar-chart"
                        [dataSource]="dxExpenditureByCategoryChartData.data">

                        <!-- Data Mapping Setup-->
                        <dxi-chart-series valueField="projection" name="SmartProperty Projections" type="bar"
                            color="#b6defa"></dxi-chart-series>
                        <dxi-chart-series valueField="actual" name="Actual YTD" type="bar" color="#45AAF2"></dxi-chart-series>
                        <dxo-chart-common-series-settings argumentField="categoryName"
                            [barPadding]="0"></dxo-chart-common-series-settings>

                        <!-- Annotations Setup -->
                        <dxo-chart-common-annotation-settings type="image" series="Actual YTD" color="transparent"
                            tooltipTemplate="annotationsTooltipTemplate" paddingLeftRight="0" paddingTopBottom="0">
                            <dxo-chart-border color="transparent"></dxo-chart-border>
                            <dxo-chart-shadow opacity="0"></dxo-chart-shadow>
                        </dxo-chart-common-annotation-settings>
                        <dxi-chart-annotation *ngFor="let data of dxExpenditureByCategoryChartAnnotations" [data]="data"
                            [argument]="data.categoryName">
                            <dxo-chart-image url="../../../../../assets/images/img-alert.png" height="20"
                                width="20"></dxo-chart-image>
                        </dxi-chart-annotation>
                        <div *dxTemplate="let annotation of 'annotationsTooltipTemplate'">
                            <div class="tooltip-container">
                                <div class="tooltip-row margin-bottom-10">
                                    <div class="col-md-12">
                                        <div class="text-warning">
                                            <div class="unexpected-expense-warning"></div>
                                            Expense was not budgeted in the {{ 'reserve study' | terminology | async }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Axis Formatting (Both Axes)-->
                        <dxo-chart-common-axis-settings opacity="0">
                            <dxo-chart-tick [visible]="false"></dxo-chart-tick>
                            <dxo-chart-label>
                                <dxo-chart-font color="#000000" size="14" weight="300"
                                    family="MuseoSans-500, sans-serif"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-common-axis-settings>

                        <!-- Y-Axis -->
                        <dxi-chart-value-axis [autoBreaksEnabled]="dxExpenditureByCategoryChartData.showAutoBreak"
                            [maxAutoBreakCount]="1">
                            <dxo-chart-break-style [line]="'waved'"> </dxo-chart-break-style>
                            <dxo-chart-label format="currency"></dxo-chart-label>
                        </dxi-chart-value-axis>

                        <!-- X Axis -->
                        <dxo-chart-argument-axis>
                            <dxo-chart-tick [visible]="true"></dxo-chart-tick>
                            <dxo-chart-label overlappingBehavior="stagger"></dxo-chart-label>
                        </dxo-chart-argument-axis>

                        <!-- Hover Tooltip -->
                        <dxo-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            interactive="true" paddingLeftRight="25" [zIndex]="2000">
                        </dxo-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container">
                                <ng-container *ngIf="checkForUnexpectedExpense(info.seriesName, info.point.data)">
                                    <div class="tooltip-row margin-bottom-10">
                                        <div class="col-md-12">
                                            <div class="text-warning">
                                                <div class="unexpected-expense-warning"></div>
                                                Expense was not budgeted in the {{ 'reserve study' | terminology | async }}
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <div class="tooltip-row margin-bottom-10">
                                    <div class="col-md-10 text-start tooltip-total">
                                        Total {{info.argument }} {{info.seriesName}}
                                    </div>
                                    <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                </div>

                                <!-- "SmartProperty Projection" Tooltip -->
                                <ng-container *ngIf="info.seriesName === 'SmartProperty Projections'">
                                    <ng-container
                                        *ngFor="let tooltipData of info.point.data.reserveStudyProjectionTooltipData">
                                        <div class="tooltip-row">
                                            <div class="col-md-10">{{tooltipData.componentName}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.anticipatedCost"></sp-fr>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/reports/anticipated-expenditures']"
                                            [queryParams]="{categoryIdFilter: info.point.data.categoryId,
                                                fundTypes: fundTypesForExpense
                                            }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>

                                <!-- "Actual YTD" Tooltip -->
                                <ng-container *ngIf="info.seriesName === 'Actual YTD'">
                                    <ng-container *ngFor="let tooltipData of info.point.data.actualYtdTooltipData">
                                        <div class="tooltip-row">
                                            <div class="col-md-2">{{tooltipData.transactionDate | date : 'MM/dd/yyyy'}} </div>
                                            <div class="col-md-3">{{tooltipData.ledgerCode}}</div>
                                            <div class="col-md-5">{{tooltipData.transactionDescription}} </div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.amount"></sp-fr></div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/transactions']" [queryParams]="{
                                                    glCodes: info.point.data.glCodes,
                                                    transactionDateStart: fiscalYearStartDate | date : 'MM-dd-yyyy',
                                                    transactionDateEnd: fiscalYearEndDate | date : 'MM-dd-yyyy',
                                                    fundTypes: fundTypesForExpense
                                                }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-chart-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-chart-legend>

                        <!-- Chart Animation -->
                        <dxo-chart-animation [enabled]="false"></dxo-chart-animation>
                    </dx-chart>
                </div>
                <div *ngIf="dxExpenditureByCategoryChartData.data.length === 0">
                    <div class="alert alert-info chart-alert">
                        No data available for this chart. Please confirm your <a
                            href="/#/useraccount/connected-apps?tabIndex=1">configurations</a> are accurate.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Summary of Reserves -->
    <div class="row">
        <div class="col-lg-12">
            <div class="section-container">
                <span class="section-title ">Summary of Reserves - Last 12 months</span>
                <div *ngIf="!dxReserveSummaryChartData.hasNoData">
                    <dx-chart #reserveSummaryBarChart id="reserve-summary-bar-chart"
                        [dataSource]="dxReserveSummaryChartData.data">

                        <!-- Data Mapping Setup-->
                        <dxo-chart-common-series-settings argumentField="monthYear" type="stackedBar" >
                        </dxo-chart-common-series-settings>
                        <dxi-chart-series valueField="reserveExpenses" name="Expense" tag="0" color="#e75e39" stack="expense"></dxi-chart-series>
                        <dxi-chart-series valueField="1" name="Contribution" tag="1" stack="income" color="#6db30b"></dxi-chart-series>
                        <dxi-chart-series valueField="2" name="Interest" tag="2" stack="income" color="#0bb37b"></dxi-chart-series>
                        <dxi-chart-series valueField="7" [name]="specialAssessmentLabel" tag="7" stack="income" color="#6dbde8" ></dxi-chart-series>
                        <dxi-chart-series valueField="3" name="Other" tag="3" stack="income" color="#a2cf63"></dxi-chart-series>

                        <!-- Axis Formatting (Both Axes)-->
                        <dxo-chart-common-axis-settings opacity="0">
                            <dxo-chart-tick [visible]="false"></dxo-chart-tick>
                            <dxo-chart-label>
                                <dxo-chart-font color="#000000" size="14" weight="300"
                                    family="MuseoSans-500, sans-serif"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-common-axis-settings>

                        <!-- Y-Axis -->
                        <dxi-chart-value-axis>
                            <dxo-chart-label format="currency"></dxo-chart-label>
                        </dxi-chart-value-axis>

                        <dxo-chart-argument-axis>
                            <dxo-chart-tick [visible]="true"></dxo-chart-tick>
                        </dxo-chart-argument-axis>

                        <!-- Hover Tooltip -->
                        <dxo-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            interactive="true" paddingLeftRight="25" [zIndex]="2000">
                        </dxo-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container">

                                <ng-container *ngIf="info.seriesName != 'Expense'">
                                    <!-- "Reserve Income" Tooltip -->
                                    <!-- Total Reserve Income-->
                                    <div class="tooltip-row  margin-bottom-10" *ngIf="info.seriesName != 'Expense'">
                                        <div class="col-md-10 text-start tooltip-total-income">Total Reserve Income
                                        </div>
                                        <div class="col-md-2 tooltip-total-income">{{ info.point.data.monthlyReserveIncome | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                                    </div>

                                    <!-- Series Total-->
                                    <div class="tooltip-row margin-bottom-10">
                                        <div class="col-md-10 text-start tooltip-total">
                                            Total {{info.argument}} {{info.seriesName}}
                                        </div>
                                        <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                    </div>

                                    <ng-container *ngFor="let tooltipData of contributionsTooltipActualData(info.point.data.contributionsTooltipData, info.point.series.tag)">
                                        <div class="tooltip-row">
                                            <div class="col-md-2 text-start">{{tooltipData.transactionDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-3 text-center">{{tooltipData.glCode}}</div>
                                            <div class="col-md-5 text-start">{{tooltipData.transactionDescription}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.amount"></sp-fr></div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/transactions']" [queryParams]="{
                                                reportingGroup: info.point.series.tag, 
                                                transactionDateMonth: info.argument,
                                                fundTypes: fundTypesForIncome
                                            }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>

                                <!-- "Reserve Expenses" Tooltip -->
                                <ng-container *ngIf="info.seriesName === 'Expense'">
                                    <!-- Series Total-->
                                    <div class="tooltip-row margin-bottom-10">
                                        <div class="col-md-10 text-start tooltip-total">
                                            Total {{info.argument}} {{info.seriesName}}
                                        </div>
                                        <div class="col-md-2 tooltip-total"><sp-fr [data]="info.value"></sp-fr></div>
                                    </div>

                                    <ng-container *ngFor="let tooltipData of info.point.data.expensesTooltipData">
                                        <div class="tooltip-row">
                                            <div class="col-md-2 text-start">{{tooltipData.transactionDate | date: 'MM/dd/yyyy'}}</div>
                                            <div class="col-md-3 text-center">{{tooltipData.glCode}}</div>
                                            <div class="col-md-5 text-start">{{tooltipData.transactionDescription}}</div>
                                            <div class="col-md-2"><sp-fr [data]="tooltipData.amount"></sp-fr></div>
                                        </div>
                                    </ng-container>

                                    <div class="tooltip-link">
                                        <a class="btn btn-link padding-right-0" target="_blank"
                                            [routerLink]="['/useraccount/transactions']" [queryParams]="{
                                                reportingGroup: [reportingGroupTypes.ReserveExpense], 
                                                transactionDateMonth: info.argument,
                                                fundTypes: fundTypesForExpense
                                            }">
                                            View All
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-chart-legend 
                            [visible]="true" 
                            [customizeItems]="hideLegendLabelIfZero" 
                            position="side" 
                            horizontalAlignment="center" 
                            verticalAlignment="bottom"></dxo-chart-legend>

                        <!-- Chart Animation -->
                        <dxo-chart-animation [enabled]="false"></dxo-chart-animation>
                    </dx-chart>
                </div>
                <div *ngIf="dxReserveSummaryChartData.hasNoData">
                    <div class="alert alert-info chart-alert">
                        No data available for this chart. Please confirm your <a
                            href="/#/useraccount/connected-apps?tabIndex=1">configurations</a> are accurate.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">

        <!-- Reserve Balance -->
        <div class="col-lg-12">
            <div class="section-container">
                <span class="section-title ">Ending Reserve Balance - Last 12 months</span>
                <div *ngIf="!dxReserveBalanceChartData.hasNoData">

                    <dx-chart #reserveBalanceLineChart id="reserve-balance-line-chart"
                        [dataSource]="dxReserveBalanceChartData.data">

                        <!-- Data Mapping Setup-->
                        <dxi-chart-series valueField="reserveBalance" name="Ending Reserve Balance" type="line"
                            color="#595959" hoverMode="nearestPoint">
                            <dxo-chart-point hoverMode="onlyPoint" size="0">
                                <dxo-chart-hover-style size="5"></dxo-chart-hover-style>
                            </dxo-chart-point>
                        </dxi-chart-series>

                        <dxo-chart-common-series-settings argumentField="monthYear"></dxo-chart-common-series-settings>

                        <!-- Axis Formatting (Both Axes)-->
                        <dxo-chart-common-axis-settings opacity="0">
                            <dxo-chart-tick [visible]="false"></dxo-chart-tick>
                            <dxo-chart-label>
                                <dxo-chart-font color="#000000" size="14" weight="300"
                                    family="MuseoSans-500, sans-serif"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-common-axis-settings>

                        <!-- Y-Axis -->
                        <dxi-chart-value-axis>
                            <dxo-chart-label format="currency"></dxo-chart-label>
                        </dxi-chart-value-axis>

                        <!-- X-Axis -->
                        <dxo-chart-argument-axis opacity="0">
                            <dxo-chart-label alignment="center" displayMode="rotate" [rotationAngle]="315">
                                <dxo-chart-font color="#000000"></dxo-chart-font>
                            </dxo-chart-label>
                        </dxo-chart-argument-axis>

                        <!-- Hover Tooltip -->
                        <dxo-chart-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                            paddingLeftRight="25" [zIndex]="2000">
                        </dxo-chart-tooltip>
                        <div *dxTemplate="let info of 'tooltipContent'">
                            <div class="tooltip-container tooltip-container-small">
                                {{info.argument}}
                                <br />
                                <strong><sp-fr [data]="info.value"></sp-fr></strong>
                            </div>
                        </div>

                        <!-- Legend -->
                        <dxo-chart-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-chart-legend>

                        <!-- Chart Animation -->
                        <dxo-chart-animation [enabled]="false"></dxo-chart-animation>

                        <!-- Crosshair -->
                        <dxo-chart-crosshair [enabled]="true" color="#949494" [width]="1" dashStyle="solid"
                            horizontalLine="false">
                            <dxo-chart-label [visible]="false"></dxo-chart-label>
                        </dxo-chart-crosshair>
                    </dx-chart>
                </div>
                <div *ngIf="dxReserveBalanceChartData.hasNoData">
                    <div class="alert alert-info">
                        No data available for this chart. Please confirm your <a
                            href="/#/useraccount/connected-apps?tabIndex=1">configurations</a> are accurate.
                    </div>
                </div>
            </div>
        </div>

        <!-- 5 Year Projection -->
        <!-- <div class="col-lg-6">
            <div class="section-container">

                <span class="section-title ">5 Year Projection</span>
                <dx-chart #fiveYearProjectionComboChart id="five-year-projection-combo-chart"
                    [dataSource]="dxFiveYearProjectionChartData">
                    
                    <dxi-series valueField="totalReserveFunds" name="Total Reserve Funds" color="#7cb305"
                        type="bar"></dxi-series>
                    <dxi-series valueField="anticipatedExpenditures" name="Anticipated Expenditures" color="#45AAF2"
                        type="bar"></dxi-series>

                    <dxi-series valueField="endingReserveBalance" name="Ending Reserve Balance" type="line"
                        color="#595959" hoverMode="nearestPoint">
                        <dxo-point hoverMode="onlyPoint" size="0">
                            <dxo-hover-style size="5"></dxo-hover-style>
                        </dxo-point>
                    </dxi-series>

                    <dxo-common-series-settings argumentField="year"></dxo-common-series-settings>
                    
                    <dxo-common-axis-settings opacity="0">
                        <dxo-tick [visible]="false"></dxo-tick>
                        <dxo-label>
                            <dxo-font color="#000000" size="14" weight="300"
                                family="MuseoSans-500, sans-serif"></dxo-font>
                        </dxo-label>
                    </dxo-common-axis-settings>

                    <dxi-value-axis>
                        <dxo-label format="currency"></dxo-label>
                        <dxo-title text="Ending Reserve Balance">
                            <dxo-font color="#000000" size="14" weight="300"
                                family="MuseoSans-500, sans-serif"></dxo-font>
                        </dxo-title>
                    </dxi-value-axis>
                    
                    <dxo-tooltip [enabled]="true" contentTemplate="tooltipContent" cornerRadius="3" color="#ffffff"
                        paddingLeftRight="25">
                    </dxo-tooltip>
                    <div *dxTemplate="let info of 'tooltipContent'">
                        <div class="tooltip-container tooltip-container-small">
                            {{info.argument}} &bull; {{info.seriesName}}
                            <br />
                            <strong><sp-fr [data]="info.value"></sp-fr></strong>
                        </div>
                    </div>
                    
                    <dxo-legend verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                    
                    <dxo-animation [enabled]="false"></dxo-animation>                    
                </dx-chart>
            </div>
        </div> -->
    </div>
</div>

<!-- No Data Message -->
<div *ngIf="hasNoComponents" class="no-components-msg">
    <div class="icon-container">
        <i class="fa-regular fa-folder-open fa-3x"></i>
    </div>
    <div>
        <h3 class="margin-top-25">Start adding {{ 'components' | terminology | async }} for your property!</h3>
        <p class="margin-top-25 font-light">Before we can generate the dashboard, you need to add {{ 'components' | terminology | async }}.</p>
        <a class="btn btn-success" [routerLink]="['/useraccount/components']">
            Manage Your {{ 'Components' | terminology | async }}
        </a>
    </div>

    <div *spHasRole="['Vendor', 'Member']">
        <h3 class="margin-top-25">There are no {{ 'components' | terminology | async }} for your property</h3>
        <p class="margin-top-25 font-light">Contact your account administrator about adding {{ 'components' | terminology | async }}.</p>
    </div>
</div>